import * as BaseSeparator from '@radix-ui/react-separator';
import type { SeparatorProps as RadixSeparatorProps } from '@radix-ui/react-separator';
import { clsx } from 'clsx';
import { Layout } from '../Layout/Layout';
import type { LayoutProps } from '../Layout/Layout';
import * as styles from './Separator.css';

interface SeparatorProps extends Omit<RadixSeparatorProps, 'color'> {
  readonly color?: LayoutProps['backgroundColor'];
}

export const Separator: React.FC<SeparatorProps> = ({
  className,
  color: backgroundColor = '$separatorColor',
  ...props
}) => (
  <Layout
    as={BaseSeparator.Root}
    backgroundColor={backgroundColor}
    className={clsx(styles.root, className)}
    {...props}
  />
);
